<div class="selection-container">
    <span class="text">{{ 'aumico_notes_super_table_mapping_row_settings_description' | i18next }}</span>
    <div class="selection-item">
        <mapping-items-selection
            [mulitpleSelection]="true"
            [mappingItemsSelectionTree]="matchingMappingItemsSelectionTree"
            [existingSelectionItemsNodes]="existingSelectionItemsNodes"
            (onSelectedItemsChange)="onSelectedItemsChange($event)"
        ></mapping-items-selection>
    </div>
</div>
